import { render, staticRenderFns } from "./ModalTemplate.vue?vue&type=template&id=0e73dff2&scoped=true&"
import script from "./ModalTemplate.ts?vue&type=script&lang=ts&"
export * from "./ModalTemplate.ts?vue&type=script&lang=ts&"
import style0 from "./ModalTemplate.scss?vue&type=style&index=0&id=0e73dff2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e73dff2",
  null
  
)

export default component.exports